import * as sxStyles from '../AnalyticsDetails.styled'
import {
  Body,
  Container,
} from '../../../../Shipment/pages/IncomingDeliveriesDetails/components/ConsistencyResult/ConsistencyResult.styled'
import { Box, Stack } from '@mui/material'
import {
  CardLoader,
  CardTitle,
  ChartExportWrapper,
  CustomDistanceChart,
} from '../../../../../components'
import { useQuery } from 'react-query'
import { useAnalyticsServices } from '../../services/services'

export const AnalysisSpectralDistanceSection = ({
  selectedDeliveryId,
  isPostAging,
  isBakerModule,
}: {
  selectedDeliveryId: string
  isPostAging: boolean
  isBakerModule: boolean
}) => {
  const { getDeliverySpectralDistance } = useAnalyticsServices(isBakerModule)

  const {
    data: spectralDistanceResponse,
    isLoading: isSpectralDistanceLoading,
  } = useQuery(
    ['flour-deliveries-spectral-distance', selectedDeliveryId, isPostAging],
    () =>
      getDeliverySpectralDistance(
        selectedDeliveryId!,
        isBakerModule ? undefined : isPostAging
      ),
    {
      enabled: !!selectedDeliveryId,
      keepPreviousData: true,
      select: (data) => data.result,
    }
  )

  const mappedChartData = spectralDistanceResponse
    ? [
        ...(spectralDistanceResponse?.historical_spectral_distances?.map(
          (historicData) => ({
            threshold: spectralDistanceResponse.threshold_line,
            point: historicData.point,
            date: historicData.arrival_date,
          })
        ) || []),
        {
          point: spectralDistanceResponse.point,
          threshold: spectralDistanceResponse.threshold_line,
          date: spectralDistanceResponse.arrival_date,
          current: true,
        },
      ]
    : []

  return (
    <Stack flex={2} sx={sxStyles.analysisStatusSectionContainer}>
      <Container>
        <Box px="16px">
          <CardTitle title="Spectral Distance" />
        </Box>
        <Body>
          {isSpectralDistanceLoading ? (
            <CardLoader />
          ) : (
            <ChartExportWrapper title="Spectral Distance">
              <CustomDistanceChart data={mappedChartData} />
            </ChartExportWrapper>
          )}
        </Body>
      </Container>
    </Stack>
  )
}
